export const modelHeaders = {
    airbnk: [],
    announcement: ['title', 'path'],
    card: ['number', 'userFullName', 'facilityCode', 'cardTypeName', 'createdAt'],
    card_format: ['id', 'name'],
    common_area: ['id', 'zone', 'fromTime', 'toTime'],
    contract: ['folio', 'contractorName', 'contractorCompanyName', 'noEmployees', 'noVehicles', 'email'],
    contractor: ['contractorCompanyName', 'name', 'lastName', 'secondLastName', 'email', 'phoneNumber', 'acronym'],
    contractor_document: ['document', 'path', 'createdAt', 'deletedAt'],
    contractor_document_company: ['document', 'departent', 'deletedAt', 'createdAt'],
    contractor_employee: ['contractor.contractorCompanyName', 'user.fullName', 'user.email', 'user.phoneNumber'],
    contractor_employee_contract: [
        'contractorEmployee.user.fullName',
        'contractorEmployee.user.email',
        'contractorEmployee.user.phoneNumber',
        'contractorEmployee.user.documentId',
    ],
    contractor_vehicle: [
        'contractor.contractorCompanyName',
        'vehicle.brand',
        'vehicle.subBrand',
        'vehicle.model',
        'vehicle.serialNumber',
    ],
    contractor_vehicle_contract: ['id', 'contractorVehicle'],
    contractor_vehicle_document: ['vehicle.brand', 'vehicle.model', 'document', 'path', 'createdAt'],
    contractor_vehicle_document_company: ['document', 'path', 'createdAt', 'deletedAt'],
    contractor_work_schedule: ['contractor.contractorCompanyName', 'from', 'to', 'deletedAt'],
    department: ['id', 'name'],
    device: ['name', 'ip', 'mac', 'zoneName'],
    employee: ['employeeId', 'userId', 'startDate', 'endDate'],
    employee_contract: ['id', 'user', 'path'],
    employee_document: ['user.fullName', 'user.email', 'document', 'path', 'createdAt'],
    employee_document_company: ['document', 'path', 'createdAt', 'deletedAt'],
    event: ['name', 'hostName', 'startDate', 'endDate'],
    firearm: [],
    firearm_type: [],
    hid: ['name', 'ipAddress', 'channelId', 'scpId', 'noSio'],
    hid_card_format: ['cardFormat.id', 'cardFormat.name', 'facilityCode', 'deletedAt'],
    hid_input: ['name', 'number', 'noSio', 'sioType', 'hidName', 'deletedAt'],
    hid_output: [],
    hid_reader: ['hidName', 'ipAddress', 'sioType', 'readerNo', 'deletedAt'],
    hid_sio: ['name', 'number', 'noSio ', 'ipAddress', 'deletedAt'],
    hid_work_shift: ['id', 'hid', 'workShift'],
    holiday: [],
    live_content: [],
    onboarding: [
        'user.name',
        'user.lastName',
        'user.secondLastName',
        'user.documentId',
        'user.phoneNumber',
        'user.email',
    ],
    onboarding_image: [],
    onboarding_process: ['process', 'deletedAt'],
    purchase: [
        'folio',
        'supplierName',
        'supplierCompanyName',
        'supplierEmployeeName',
        'supplierVehicleBrand',
        'item',
        'deliveryDate',
    ],
    relative: [],
    report: [],
    reservation: ['zone.name', 'zone.createdAt', 'fromTime', 'toTime', 'reservationDate', 'deletedAt'],
    resource: ['id', 'name', 'path'],
    role: ['name', 'createdAt', 'updatedAt', 'deletedAt'],
    smart_lock: [],
    supplier: ['supplierCompanyName', 'name', 'lastName', 'secondLastName', 'email', 'phoneNumber'],
    supplier_document: ['id', 'status', 'user'],
    supplier_document_company: ['document', 'path', 'createdAt', 'deletedAt'],
    supplier_employee: ['supplier.supplierCompanyName', 'user.fullName', 'user.email', 'user.phoneNumber'],
    supplier_vehicle: ['supplier.supplierCompanyName', 'vehicle.brand', 'vehicle.model', 'vehicle.plate', 'deletedAt'],
    supplier_vehicle_document: ['document', 'vehicle.brand', 'vehicle.plate', 'path', 'createdAt', 'deletedAt'],
    supplier_vehicle_document_company: ['document', 'path', 'createdAt', 'deletedAt'],
    tag: ['id', 'vehicle', 'tag'],
    template: ['id', 'name'],
    user_announcement: ['user.name', 'announcement.title', 'announcement.path', 'deletedAt'],
    user_image: [
        'user.name',
        'user.lastName',
        'user.secondLastName',
        'user.documentId',
        'user.phoneNumber',
        'user.email',
    ],
    user_invitation: ['hostName', 'visitorName', 'visitorEmail', 'visitorPhoneNumber', 'zoneName'],
    user_process: ['id', 'user', 'onboardingProcess'],
    user_vehicle_company: ['id', 'vehicleCompany', 'employee'],
    user_work_schedule: ['user.fullName', 'from', 'to', 'deletedAt'],
    user_zone: ['id', 'user', 'zone'],
    vehicle_company: ['vehicle.brand', 'vehicle.subBrand', 'vehicle.model', 'vehicle.createdAt'],
    vehicle_image: ['path', 'deletedAt'],
    vehicle_invitation: [],
    work_shift: ['id', 'name'],
    work_shift_schedule: ['workShift.name', 'from', 'to', 'deletedAt'],
    zone: ['name', 'createdAt', 'updatedAt'],
    zone_plane: ['id', 'zone.name', 'name'],
};
